import { render, staticRenderFns } from "./MemberAreaCategories.vue?vue&type=template&id=0e891865&scoped=true&"
import script from "./MemberAreaCategories.vue?vue&type=script&lang=js&"
export * from "./MemberAreaCategories.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaCategories.vue?vue&type=style&index=0&id=0e891865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e891865",
  null
  
)

export default component.exports